import { Utilities } from "./Utilities";

export interface ITableInLineEditsResult {
    success: Boolean;
    value: String;
}

export class TableInLineEdits {

    // ----------------------------------------------------------- //
    // OPEN PROMPT
    static setTableEdit_TextInput = (field, value, row, $element): Promise<ITableInLineEditsResult> => {
        return new Promise<ITableInLineEditsResult>((resolve, reject) => {
            try {
                // Check if this cell is already in edit mode, if it is, then return
                if ($element.data('isediting') == true) return;
                else $element.data('isediting', true);

                // Set the null value
                if (value == "null" || value == null) value = "";

                // Create an input element
                var inputEl = document.createElement('input');
                inputEl.setAttribute('type', 'text');
                inputEl.setAttribute('style', 'width: 100%;');
                inputEl.setAttribute('value', value);
                $element.append(inputEl);

                // Hide the text element
                $element.find('div').css('display', 'none');

                // On lose focus
                $element.find('input').off('focusout');
                $element.find('input').on('focusout', function () {
                    $element.find('div span').text($(this).val()); // Update the element text
                    $element.find('div').css('display', 'block');

                    row[field] = $(this).val(); // Update the table data
                    $(this).remove(); // Remove the input element
                    $element.data('isediting', false) // set to not editing

                    resolve({ success: true, value: row[field] });
                });

                // Focus the input element
                $element.find('input').focus();
                $element.find('input')[0].setSelectionRange(value.length, value.length); // Scroll to the end of the text
            }
            catch (e) {
                reject({ success: false });
            }
        });
    }

    static setTableEdit_CheckBox = ($element: JQuery<HTMLElement>): Promise<ITableInLineEditsResult> => {
        return new Promise<ITableInLineEditsResult>((resolve, reject) => {
            try {
                var checked = $element.find("input").is(":checked");
                resolve({ success: true, value: checked == true ? "true" : "false" });
            }
            catch (e) {
                reject({ success: false });
            }
        });
    }
}






